<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <h1 class="display-1">Firmware</h1>
      </v-flex>
    </v-layout>

    <v-alert v-if="success" :value="true" type="success">Fichier mis en ligne : {{ filename }}</v-alert>

    <v-form>
      <v-container>
        <v-alert :value="error_message" type="error">{{ error_message}}</v-alert>

        <v-layout>
          <v-flex xs12 md4>
            Fichier
            <br>
            <input type="file" ref="fileInput" v-on:change="handleFileUpload()">
          </v-flex>

          <v-flex xs12 md4>
            <v-btn color="primary" @click="submit()">Envoyer</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <div class="mt-5">
      <b>Fichiers en ligne</b>
      <div v-for="file of onlineFileList" :key="file">
        {{ file }}
        <v-btn icon dark color="primary" small flat @click="removeFileConfirm(file)">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    error_message: null,
    success: false,
    file: null,
    filename: null,
    onlineFileList: []
  }),
  methods: {
    handleFileUpload() {
      this.success = false;
      this.filename = null;
      this.file = this.$refs["fileInput"].files[0];
    },
    // validation formulaire
    submit() {
      // données du formulaire
      var formData = new FormData();
      formData.append("file", this.file);
      // requête
      this.api
        .postForm("/admin/files", formData)
        .then(res => {
          this.error_message = null;
          this.filename = res.data;
          this.success = true;
          // recharge
          this.loadFileList();
        })
        .catch(err => {
          this.error_message = err.message;
          this.filename = null;
          this.success = false;
        })
        .finally(() => {
          this.file = null;
          this.$refs["fileInput"].value = null;
        });
    },
    // chargement de la liste des fichiers
    loadFileList() {
      this.api
        .get("/admin/files")
        .then(res => {
          this.onlineFileList = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },

    // supression de fichier, confirmation
    removeFileConfirm(file) {
      if (window.confirm("Supprimer le fichier " + file + " ? ")) {
        this.removeFile(file);
      }
    },
    // supression d'un fichier
    removeFile(file) {
      this.api
        .delete("/admin/files/" + file)
        .then(() => {
          this.loadFileList();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  mounted() {
    this.loadFileList();
  }
};
</script>
